"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _firestorePlus = require("firestore-plus");

var yup = _interopRequireWildcard(require("yup"));

var types = _interopRequireWildcard(require("../types"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

class ReviewSchema extends _firestorePlus.Schema {
  static postValidate(data) {
    console.log("[ReviewSchema#postValidate]", data);
  }

}

exports.default = ReviewSchema;
ReviewSchema.fieldTypes = {
  createdAt: types.DateTime,
  rating: yup.number(),
  reviewer_name: yup.string(),
  reviewer_img: yup.string(),
  reviewer: types.Firestore.DocumentReference
};
//# sourceMappingURL=Review.js.map